/**
 * Reactive cursor data for raw, target, smoothed and step deltas.
 */
export class CursorState {
  /**
   * Target X position of the cursor (e.g., from `mousemove`)
   */
  targetX: number = 0

  /**
   * Target Y position of the cursor.
   */
  targetY: number = 0

  /**
   * Smoothed X position after applying lerp.
   */
  smoothedX: number = 0

  /**
   * Smoothed Y position after applying lerp.
   */
  smoothedY: number = 0

  /**
   * Delta step between current and target X (used internally for lerp).
   */
  stepX: number = 0

  /**
   * Delta step between current and target Y.
   */
  stepY: number = 0
}
